import { hotRanks } from "../../../mocks/baogua";

const medal = ["text-[#ff4d3d]", "text-orange-400", "text-amber-500"];

export default function HotRank() {
  return (
    <section id="rank" className="relative mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <h2 className="font-serif-cn text-2xl md:text-4xl font-black text-[#201d1a] flex items-center gap-3">
            <span className="grid w-11 h-11 rounded-xl bg-gradient-to-br from-[#ff4d3d] to-orange-400 text-white items-center justify-center">
              <i className="ri-fire-fill w-6 h-6 flex items-center justify-center"></i>
            </span>
            今日热搜榜
          </h2>
          <p className="mt-3 text-[#201d1a]/60">每分钟更新的全网热议排行，看看大家今天都在吃什么瓜。</p>
        </div>
        <span className="inline-flex items-center gap-2 rounded-full bg-emerald-600/10 text-emerald-700 text-sm font-medium px-4 py-1.5 self-start md:self-auto">
          <i className="ri-broadcast-line w-4 h-4 flex items-center justify-center"></i> 实时更新中
        </span>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        {hotRanks.map((item, i) => (
          <article
            key={item.id}
            className="group flex gap-4 p-4 md:p-5 rounded-2xl bg-white border border-amber-900/10 hover:border-emerald-600/30 transition-colors cursor-pointer"
          >
            <div className={`shrink-0 w-11 h-11 rounded-xl grid place-items-center font-serif-cn font-black text-xl ${i < 3 ? "text-white bg-[#ff4d3d]" : "bg-amber-100 text-amber-700"}`}>
              {i < 3 ? <i className="ri-vip-crown-2-fill w-6 h-6 flex items-center justify-center"></i> : i + 1}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                {item.tag && (
                  <span className="grid w-5 h-5 place-items-center rounded-md bg-[#ff4d3d] text-white text-xs font-bold">{item.tag}</span>
                )}
                <span className="text-xs text-emerald-700 bg-emerald-600/10 px-2 py-0.5 rounded whitespace-nowrap">{item.category}</span>
                <span className="text-xs text-[#201d1a]/40 whitespace-nowrap">{item.time}</span>
              </div>
              <h3 className="mt-2 font-semibold text-[#201d1a] leading-snug group-hover:text-emerald-700 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm text-[#201d1a]/55 line-clamp-2">{item.excerpt}</p>
              <div className="mt-2.5 flex items-center gap-4 text-xs text-[#201d1a]/50 flex-wrap">
                <span className="flex items-center gap-1"><i className={`ri-fire-fill w-4 h-4 flex items-center justify-center ${medal[i] || "text-orange-400"}`}></i>{item.heat}热度</span>
                <span className="flex items-center gap-1"><i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>{item.comments.toLocaleString()}条评论</span>
                <span className="flex items-center gap-1"><i className="ri-heart-3-line w-4 h-4 flex items-center justify-center"></i>{item.likes.toLocaleString()}人赞过</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}